
let blackFridayWrap = document.querySelector(".as-black-friday-landing-page-wrap")
if (blackFridayWrap) {
  let blackFridayImage1 = blackFridayWrap.querySelector(".as-black-friday-image-1")
  let blackFridayImage2 = blackFridayWrap.querySelector(".as-black-friday-image-2")
  let proPane = document.querySelector(".as-pro-pane")

  let blackFridayImage3 = blackFridayWrap.querySelector(".as-black-friday-image-3")
  let blackFridayImage4 = blackFridayWrap.querySelector(".as-black-friday-image-4")
  let proPane2 = document.querySelector(".text-over-image.as-section-text-over-image.rounded-1.overflow-hidden")
  
  let initLocation = ()=>{
    if (window.innerWidth > 768) {
      if (blackFridayImage1 && proPane) {
        blackFridayImage1.style.top = proPane.offsetTop - blackFridayImage1.offsetHeight * 0.8 + "px"
        blackFridayImage1.style.right = proPane.offsetLeft - blackFridayImage1.offsetHeight * 0.4 + "px"
      }
      if (blackFridayImage2 && proPane) {
        blackFridayImage2.style.top = proPane.offsetTop - blackFridayImage2.offsetHeight * 0.7 + "px"
        blackFridayImage2.style.right = "30%"
      }
      if (blackFridayImage3 && proPane2) {
        blackFridayImage3.style.top = proPane2.offsetTop - blackFridayImage3.offsetHeight * 0.6 + "px"
        blackFridayImage3.style.right = "20%"
      }
      if (blackFridayImage4 && proPane2) {
        blackFridayImage4.style.top = proPane2.offsetTop + proPane2.offsetHeight * 0.5 + "px"
        blackFridayImage4.style.left = "-3%"
      }
    }else{
      if (blackFridayImage1 && proPane) {
        blackFridayImage1.style.top = proPane.offsetTop + proPane.offsetHeight * 0.5 + "px"
        blackFridayImage1.style.left = "-3%"
      }
      if (blackFridayImage2 && proPane) {
        blackFridayImage2.style.top = proPane.offsetTop - blackFridayImage2.offsetHeight * 0.6 + "px"
        blackFridayImage2.style.right = 0 - blackFridayImage2.offsetWidth * 0.2 + "px"
      }
      if (blackFridayImage3 && proPane2) {
        blackFridayImage3.style.top = proPane2.offsetTop - blackFridayImage3.offsetHeight * 0.6 + "px"
        blackFridayImage3.style.right = 0 - blackFridayImage3.offsetWidth * 0.2 + "px"
      }
      if (blackFridayImage4 && proPane2) {
        blackFridayImage4.style.top = proPane2.offsetTop + proPane2.offsetHeight * 0.5 + "px"
        blackFridayImage4.style.left = 0 - blackFridayImage4.offsetWidth * 0.3 + "px"
      }
    }
  }
  initLocation()
  window.addEventListener("resize", ()=>{
    initLocation()
  })
  window.addEventListener("load", ()=>{
    initLocation()
  })
}
